export function BillingTypeRenderer(params) {
    return <div className="badge bg-primary text-white px-2 py-1 rounded">{params.value}</div>
}
